import React, {useEffect, useState} from 'react'
import ShareMobileLayer from "estimate_list/components/share/newShare/share_layer/index";
import {Api} from "estimate_list/libs/api";
import styled from "styled-components";

/**
 * styled component로 변경
 */

export const WrapperShare = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: right;
    align-items: center;
    padding: 5px 10px;
    font-size: 0;
    background: #fff;
    text-align: right;

    span{
        display: inline-block;
        font-size: 12px;
        color: #666;
        vertical-align: middle;
    }
`
const WrapperBtn = styled.button`
    display: flex;
    align-items: center;
    background-color: white;
    border: 1px solid #fff;
    padding: 0px 0 0 6px;
    width: 36px;
    height: 36px;
    border-radius: 18px;
    color: #fff;
    cursor: pointer;

    &:hover {
        color: #418ded;
        border-color: #418ded;
    }

    i {
        font-size: 20px
    }
`

/**
 * 함수형으로 변경
 * @returns {JSX.Element}
 * @constructor
 */
const Share = () => {
    const [isShowLayer, setIsShowLayer] = useState(false);
    const [isLogin, setIsLogin] = useState(false);

    /**
     * 로그인 여부 확인을 위한 api 통신
     * @returns {Promise<void>}
     */
    const getLoginData = async () => {
        const rst = await Api.getUserInfo()
        setIsLogin(rst.data.isLogin)
    }

    /**
     * 로그인 일 경우에는 layer 노출
     * 로그아웃 일 경우에는 sso 페이지로 이동
     */
    const onClickShare = () => {
        if (!isLogin) {
            window.location.href = process.env.REACT_APP_SSO_URL
            return
        } else {
            setIsShowLayer(true)
        }
    }

    useEffect(() => {
        getLoginData()
    }, []);

    return (
        <WrapperShare className="share_btn_wrapper">
            <WrapperBtn type="button" className="share_btn" onClick={onClickShare}>
                <i className="icon-share2" />
            </WrapperBtn>
            {isShowLayer && <ShareMobileLayer setIsShowLayer={setIsShowLayer}/>}
        </WrapperShare>
    )
}

export default Share;



// WEBPACK FOOTER //
// ./src/estimate_list/components/share/newShare/index.js